module.exports = __webpack_public_path__ + "static/media/dude-illustration.83b87e00.jpg";